import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// const echo = new Echo({
//     broadcaster: "pusher",
//     key: process.env.REACT_APP_PUSHER_APP_KEY,
//     wsHost: process.env.REACT_APP_WS_HOST,
//     wsPort: process.env.REACT_APP_WS_PORT,
//     wssPort: process.env.REACT_APP_WS_PORT,
//     forceTLS: false,
//     disableStats: true,
//     encrypted: false,
//     cluster: "mt1",
//     authEndpoint: process.env.REACT_APP_API_URL + "/broadcasting/auth",
//     auth: {
//         headers: {
//             Authorization: `Bearer ${localStorage.getItem('token')}`,
//             Accept: 'application/json',
//         }
//     },
//     enabledTransports: ['ws', 'wss'],
// });

export function createEcho(token) {
    return new Echo({
        broadcaster: "pusher",
        key: process.env.REACT_APP_PUSHER_APP_KEY,
        cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
        forceTLS: true,
        disableStats: true,
        encrypted: false,
        authEndpoint: `${process.env.REACT_APP_API_URL}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
                // "X-Authorization": `Bearer ${token}`,
                Accept: "application/json",
            },
        },
    });
}